/**
 * @name EmployeeService
 * @description Servicio para gestionar la información del empleado
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Consulta los empleados de una empresa
 * @param {any} request filter { idPuesto, idNivel, idArea, idSucursal, idReporta, nombre, estatus, idAplicacion, codigoColaborador, ordenarPorFechaDeAlta, columnas}
 * @return {any} promise
 */
const get = (request) => {
  let jobId = request.filter.idPuesto === undefined ? '' : `&idPuesto=${request.filter.idPuesto}`;
  let levelId = request.filter.idNivel === undefined ? '' : `&idNivel=${request.filter.idNivel}`;
  let areaId = request.filter.idArea === undefined ? '' : `&idArea=${request.filter.idArea}`;
  let branchId = request.filter.idSucursal === undefined ? '' : `&idSucursal=${request.filter.idSucursal}`;
  let supervisorId = request.filter.idReporta === undefined ? '' : `&idReporta=${request.filter.idReporta}`;
  let name = request.filter.nombre === undefined ? '' : `&nombre=${request.filter.nombre}`;
  let status = request.filter.estatus === undefined ? '' : `&estatus=${request.filter.estatus}`;
  let appId = request.filter.idAplicacion === undefined ? '' : `&idAplicacion=${request.filter.idAplicacion}`;
  let codeEmployee = request.filter.codigoColaborador === undefined ? '' : `&codigoColaborador=${request.filter.codigoColaborador}`;
  let isBackup = request.filter.esBackup === undefined ? '' : `&EsBackup=${request.filter.esBackup}`;
  let orderStartDate = request.filter.ordenarPorFechaDeAlta === undefined ? '' : `&ordenarPorFechaDeAlta=${request.filter.ordenarPorFechaDeAlta}`;
  let columns = request.columnas === undefined ? '' : `&columnas=${request.columnas}`;

  let URL = `${BASE_URL}/Empleado?paginado=${request.page},${request.size}${jobId}${levelId}${areaId}${branchId}${supervisorId}${name}${status}${appId}${codeEmployee}${isBackup}${orderStartDate}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta la información del usuario
 * @param {any} request IdEmpleado
 * @return {any} promise 
 */
const getOne = (request) => {
  let URL = `${BASE_URL}/Empleado/${request}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta información general del usuario
 * @return {any} promise
 */
const getInfo = () => {
  let URL = `${BASE_URL}/Empleado/InfoGeneral`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta información general del usuario externo
 * @param {string} externalUser
 * @return {any} promise
 */
const getInfoExternal = (externalUser) => {
  let URL = `${BASE_URL}/EmpleadoExterno/InfoGeneral?Usuario=${externalUser}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta la estructura del empleado
 * @param {any} request filter { idAplicacion, tipoEstructura, estructuraDirecta, nombre, columnas }
 * @param {boolean} tipoEstructura Parámetro en 'TRUE' para incluir al colaborador que consulta en la consulta.
 * @param {boolean} estructuraDirecta Parámetro en 'FALSE' consulta toda la estructura completa del colaborador y en 'TRUE' consulta hijos y nietos del colaborador.
 * @return {any} promise
 */
const getStructure = (request) => {
  let appId = request.filter.idAplicacion === undefined ? '' : `&idAplicacion=${request.filter.idAplicacion}`;
  let typeStructure = request.filter.tipoEstructura === undefined ? '' : `&tipoEstructura=${request.filter.tipoEstructura}`;
  let directStructure = request.filter.estructuraDirecta === undefined ? '' : `&estructuraDirecta=${request.filter.estructuraDirecta}`;
  let name = request.filter.nombre === undefined ? '' : `&nombre=${request.filter.nombre}`;
  let columns = request.columnas === undefined ? '' : `&columnas=${request.columnas}`;
  let URL = `${BASE_URL}/EmpleadoEstructura/?paginado=${request.page},${request.size}${appId}${typeStructure}${directStructure}${name}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta la estructura del empleado con información completa
 * @param {any} request filter { idPuesto, idNivel, idArea, idSucursal, idReporta, nombre, estatus, esFacilitador, nivelEstructuraInicioRango, nivelEstructuraFinRango, columnas }
 * @param {any} request filter { idAplicacion, tipoEstructura, estructuraDirecta, nombre, columnas}
 * @return {any} promise
 */
const getStructureComplete = (request) => {
  let jobId = request.filter.idPuesto === undefined ? '' : `&idPuesto=${request.filter.idPuesto}`;
  let levelId = request.filter.idNivel === undefined ? '' : `&idNivel=${request.filter.idNivel}`;
  let areaId = request.filter.idArea === undefined ? '' : `&idArea=${request.filter.idArea}`;
  let branchId = request.filter.idSucursal === undefined ? '' : `&idSucursal=${request.filter.idSucursal}`;
  let supervisorId = request.filter.idReporta === undefined ? '' : `&idReporta=${request.filter.idReporta}`;
  let name = request.filter.nombre === undefined ? '' : `&nombre=${request.filter.nombre}`;
  let status = request.filter.estatus === undefined ? '' : `&estatus=${request.filter.estatus}`;
  let isSupervisor = request.filter.esFacilitador === undefined ? '' : `&esFacilitador=${request.filter.esFacilitador}`;
  let levelStructureStart = request.filter.nivelEstructuraInicioRango === undefined ? '' : `&nivelEstructuraInicioRango=${request.filter.nivelEstructuraInicioRango}`;
  let levelStructureEnd = request.filter.nivelEstructuraFinRango === undefined ? '' : `&nivelEstructuraFinRango=${request.filter.nivelEstructuraFinRango}`;
  let columns = request.columnas === undefined ? '' : `&columnas=${request.columnas}`;
  let URL = `${BASE_URL}/EmpleadoEstructura/Completo?paginado=${request.page},${request.size}${jobId}${levelId}${areaId}${branchId}${supervisorId}${name}${status}${isSupervisor}${levelStructureStart}${levelStructureEnd}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta la jerarquía del usuario
 * @return {int} 1: User, 2: Supervisor, 3: 3rd Level
 */
const getHierarchy = () => {
  let employee = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;
  return {
    level: employee.NivelJerarquia,
    employeeId: employee.IdEmpleado
  };
};

/**
 * Actualiza información del perfil del usuario
 * @param {any} request Empleado (tel, language)
 * @return {any} promise
 */
const putProfile = (request) => {
  let employee = {};

  if (request.phone) {
    employee.Telefono = request.phone;
  } else if (request.phone === '') {
    employee.Telefono = null;
  }
  employee.IdUsuario = request.IdUsuario;
  employee.Idioma = request.language;

  let URL = `${BASE_URL}/Empleado`;

  return axios.put(URL, employee).then(({ data }) => {
    return data;
  });
};

export const EmployeeService = {
  get,
  getOne,
  getInfo,
  getInfoExternal,
  getStructure,
  getStructureComplete,
  getHierarchy,
  putProfile,
};